// src/blogs/PosterGrid.jsx
// No real poster art exists yet — each card is a deterministic CSS gradient
// keyed off the post's `extra.posterSeed`, standing in for a real <img> later.
import React from "react";

function posterGradient(seed) {
  const h1 = (seed * 37) % 360;
  const h2 = (h1 + 40) % 360;
  return `linear-gradient(160deg, hsl(${h1} 45% 30%), hsl(${h2} 55% 18%))`;
}

export default function PosterGrid({ posts, onSelectPost }) {
  return (
    <div className="poster-grid">
      {posts.map((post) => (
        <button
          key={post.id}
          type="button"
          className="poster-grid__card"
          style={{ backgroundImage: posterGradient(post.extra.posterSeed) }}
          onClick={() => onSelectPost(post.id)}
          title={post.title}
        >
          <span className="poster-grid__title">{post.title}</span>
        </button>
      ))}
    </div>
  );
}
